import { gql } from "@apollo/client";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import EventAvatar, { EventAvatarFragment } from "molecules/EventAvatar";
import React from "react";

export const PotwEntryDetailsFragment = gql`
  fragment PotwEntryDetailsFragment on PotwEntry {
    id
    rank
    title
    subtitle
    event {
      id
      ...EventAvatarFragment
    }
  }
  ${EventAvatarFragment}
`;

export default function PotwEntryDetails({ potwEntry }) {
  return (
    <div
      style={{
        padding: 5,
        display: "flex",
        flexFlow: "row wrap",
        alignItems: "center",
        gap: 8,
        fontFamily: FONT_FAMILY_GRAPHIK,
      }}
    >
      <div
        style={{
          fontStyle: "italic",
        }}
      >
        <span style={{ opacity: 0.3 }}>{"#"}</span>
        <span
          style={{
            opacity: 1,
            fontSize: "1.6em",
          }}
        >
          {potwEntry?.rank}
        </span>
      </div>
      <EventAvatar size={32} event={potwEntry?.event} />
      <div style={{ fontWeight: 500 }}>
        {potwEntry?.title}
        <div
          style={{
            marginTop: 2,
            fontSize: ".8em",
            opacity: 0.7,
            fontWeight: "normal",
          }}
        >
          {potwEntry?.subtitle}
        </div>
      </div>
    </div>
  );
}
